var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCellPhoneDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.586 1.5H9.429C8.36 1.5 7.5 2.377 7.5 3.466v23.068c0 1.089.86 1.966 1.929 1.966H20.57c1.068 0 1.929-.877 1.929-1.966V3.466c.015-1.089-.86-1.966-1.914-1.966zm.475 21.872H8.954V4.812h12.107v18.56zM17.589 3.497h-5.163v-.575h5.163v.575zm2.21-.258c0 .273-.222.5-.49.5a.499.499 0 0 1 0-.999c.268-.015.49.212.49.5zm-2.433 23.174h-4.703V24.93h4.703v1.483z",
    fill: "#7A8E96",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCellPhoneDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-cell-phone-dark.71d57f862fe9525b8ff5d6cf1db8b40d.svg";